module.exports = __webpack_public_path__ + "static/media/tictactoe.a9fa2e78.PNG";